define("shared/components/shared/carousel/controls", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div ...attributes>
    {{#if this.canGoLeft}}
      <Shared::Ui::Button @onClick={{fn @updateIndex -1}} @variant="unstyled">
        <span class="cCP--slide__prev">
          {{svg-jar "nav-left" class="o--icon o--icon--white"}}
        </span>
      </Shared::Ui::Button>
    {{/if}}
  
    {{#if this.canGoRight}}
      <Shared::Ui::Button @onClick={{fn @updateIndex 1}} @variant="unstyled">
        <span class="cCP--slide__next">
          {{svg-jar "nav-right" class="o--icon o--icon--white"}}
        </span>
      </Shared::Ui::Button>
    {{/if}}
  </div>
  */
  {
    "id": "r4rd34UE",
    "block": "[[[11,0],[17,1],[12],[1,\"\\n\"],[41,[30,0,[\"canGoLeft\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@onClick\",\"@variant\"],[[28,[37,2],[[30,2],-1],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,0,\"cCP--slide__prev\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"nav-left\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canGoRight\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@onClick\",\"@variant\"],[[28,[37,2],[[30,2],1],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,0,\"cCP--slide__next\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"nav-right\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@updateIndex\"],false,[\"if\",\"shared/ui/button\",\"fn\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/carousel/controls.hbs",
    "isStrictMode": false
  });
  class CarouselControlsComponent extends _component2.default {
    get canGoLeft() {
      return this.args.index > 0;
    }
    get canGoRight() {
      const items = this.args.carouselMediaItems;
      return this.args.index < items.length - 1;
    }
  }
  _exports.default = CarouselControlsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CarouselControlsComponent);
});